import script from "./ShowNoShowBookingCountComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowNoShowBookingCountComponent.vue?vue&type=script&setup=true&lang=js"

import "./ShowNoShowBookingCountComponent.vue?vue&type=style&index=0&id=ca485c02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca485c02"]])

export default __exports__